import cacheService from '../../../services/cacheService';
import submitCommand from '../../../services/submitCommand';
import { generateUUID } from '../../../services/uuid';
import { TrialLicenseGrantedEventResponse } from '../models/response';

export const grantTrialLicense: (
  ownerId: string,
  orgId: string,
  itemNumber: string,
  zipCode: string,
  initiatingUserId: string
) => Promise<TrialLicenseGrantedEventResponse> = (ownerId, orgId, itemNumber, zipCode, initiatingUserId) => {
  cacheService.removeAllInPath(`/v1/org/curriculum/access`);
  cacheService.removeAllInPath(`/v1/licenses`);

  return generateUUID((id: string) =>
    submitCommand(
      id,
      { id, ownerId, orgId, itemNumber, zipCode, initiatingUserId },
      'GrantTrialLicense',
      'TrialLicenseGranted',
      'GrantTrialLicenseFailed'
    )
  );
};

export const grantTrialLicenses: (
  itemsNumbers: string[],
  userId: string,
  orgId: string,
  zipCode: string,
  initiatingUserId: string
) => Promise<TrialLicenseGrantedEventResponse[]> = (itemsNumbers, userId, orgId, zipCode, initiatingUserId) =>
  new Promise<TrialLicenseGrantedEventResponse[]>((resolve, reject) => {
    Promise.allSettled(
      itemsNumbers.map(itemNumber => grantTrialLicense(userId, orgId, itemNumber, zipCode, initiatingUserId))
    ).then(responses => {
      const fulfilledResponses = responses.filter(res => res.status === 'fulfilled');

      if (fulfilledResponses.length > 0) {
        return resolve(fulfilledResponses.map(res => (res as any).value));
      }

      const errorResponses = responses.filter(res => res.status === 'rejected');

      if (errorResponses.some(res => (res as any).reason.reason === 'AlreadyGranted')) {
        return reject({ reason: 'AlreadyGranted' });
      }

      reject({ reason: 'UnknownError' });
    });
  });
